import React from "react";
import "../styling/MunicipalityText.css";

const Stockholm = () => {
  return (
    <div className="outer-wrapper">
      <div className="content-wrapper">
        <h2 className="content-title">Lediga lokaler i Stockholm</h2>
        <p className="content-text">
          Stockholm är Sveriges ekonomiska nav – en huvudstadsregion med starka
          kluster inom tech, finans, life science, offentlig sektor och kreativa
          näringar. Med tunnelbana, pendeltåg, tvärbana och nära förbindelser
          till Arlanda och Bromma är det enkelt för kunder och medarbetare att
          ta sig hit. På Vakansa hittar du kontor, kontorshotell/coworking,
          butik, lager/logistik, showroom/studio, vård- och idrottslokaler – och
          vi hjälper dig jämföra alternativ och boka visning.
        </p>
        <h3>Varför hyra lokal i Stockholm?</h3>
        <ul className="content-ol">
          <li>
            <b>Tillgång till talang & kunder:</b> Stor arbetsmarknad,
            universitet och många beslutsfattare på samma plats.
          </li>
          <li>
            <b>Kommunikationer:</b> T-bana och pendel i flera riktningar, plus
            Arlanda/Bromma för snabba resor.
          </li>
          <li>
            <b>Affärskluster:</b> Från CBD/City till Hagastaden (life science)
            och Kista (IT/telekom).
          </li>
          <li>
            <b>Flexibilitet:</b> Allt från flexplats i coworking till egna
            våningsplan – väx i takt med behoven.
          </li>
        </ul>
        <h3>Populära områden</h3>
        <ul className="content-ol">
          <li>
            <b>City/CBD (Norrmalm):</b> Representativa kontor, närhet till
            Centralstationen och allt serviceutbud.
          </li>
          <li>
            <b>Södermalm:</b> Kreativa verksamheter, studio- och
            kontorslösningar nära restauranger och kultur.
          </li>
          <li>
            <b>Östermalm:</b> Premiumadress och närhet till kunder inom finans,
            juridik och rådgivning.
          </li>
          <li>
            <b>Vasastan/Hagastaden:</b> Kontor och labbnära miljöer i ett
            växande life science-område.
          </li>
          <li>
            <b>Kungsholmen:</b> Moderna kontor, god tillgång till service,
            gångavstånd till City.
          </li>
          <li>
            <b>Kista/Science City:</b> Tech/telekom, datacenter och större
            campusliknande kontor.
          </li>
          <li>
            <b>Hammarby Sjöstad/Södra Hammarbyhamnen:</b> Media/tech, vattennära
            lägen och moderna hus.
          </li>
          <li>
            <b>Bromma/Ulvsunda & Årsta/Partihallsområdet:</b> Lätt industri,
            lager och citynära logistiklösningar.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Stockholm;
